import { useTranslation } from 'react-i18next';
import { PosInputSearch } from 'pos-client/components/shared/Form/Search/PosSearchInput.tsx';
import { PosColumn } from 'pos-client/components/shared/Layout/Grid/PosColumn.tsx';
import { PosGrid } from 'pos-client/components/shared/Layout/Grid/PosGrid.tsx';
import { useTableData } from 'pos-client/hooks/useTableData.ts';

import { useAssetTypesQuery } from './hooks/useAssetTypesQuery.tsx';
import { AssetTypesTable } from './AssetsTypesTable.tsx';

export const AssetTypesSearchForm = () => {
  const { t } = useTranslation();
  const { assetTypes, isLoading, formFilters, setFormFilters, onPageChange } =
    useAssetTypesQuery({ sortAscending: true });
  const tableData = useTableData(assetTypes?.results, (x) => x.id);

  const handleSearch = (query: string) => {
    setFormFilters((filters) => ({
      ...filters,
      name: `${query}`,
    }));
  };

  return (
    <>
      <PosGrid filters>
        <PosColumn span={24} lg={12} xl={8}>
          <PosInputSearch
            placeholder={t('assets.inputPlaceholder')}
            defaultValue={formFilters.name}
            onSearch={handleSearch}
            name="searchQuery"
            size="large"
            allowClear
          />
        </PosColumn>
      </PosGrid>

      <AssetTypesTable
        data={tableData}
        isLoading={isLoading}
        pagination={{
          current: assetTypes?.pageNumber || 1,
          total: assetTypes?.totalResults || 0,
          pageSize: formFilters?.resultsPerPage || 10,
          onChange: onPageChange,
          showSizeChanger: true,
          showTotal: (total) => t('items.totalItemsCount', { count: total }),
        }}
      />
    </>
  );
};
